module.exports = __webpack_public_path__ + "img/4.dafa9a9d.png";